// extracted by mini-css-extract-plugin
export var redoItem = "_redotech-redo-web-lib-components-ui-select-redo-item";
export var redoTrigger = "_redotech-redo-web-lib-components-ui-select-redo-trigger";